import { db } from "@react-native-firebase/database";
import { getLocalStorageItem } from "core/helpers";
import { get, ref } from "firebase/database";
import jwtDecode from "jwt-decode";

export  const isAdminUser=(user)=>
    {
      if(user.accessToken)
        {
          const decodedToken = jwtDecode(user.accessToken);
          if(decodedToken&&decodedToken.admin)
            {
              return true
            }
          else{
            return false
          }
        }
      else 
      {
        return false
      }
    }


    export const fetchUserName = async () => {
      try {
        const loggedinUser = getLocalStorageItem("loggedinUser");
        if (loggedinUser) {
          const dbRef = ref(db, `profile/${loggedinUser.uid}`);
          const snapshot = await get(dbRef);
          if (snapshot.exists()) {
            const userFetchedData = snapshot.val();
            return `${userFetchedData.firstName} ${userFetchedData.lastName}`;
          } else {
            return '';
          }
        } else {
          return '';
        }
      } catch (error) {
        console.error("Error reading data:", error.message);
        return '';
      }
    };

export const fetchUserNotificationPreferences = async (uid:string) => {
  const dbRef = ref(db, `notification/${uid}`);
  try {
      const snapshot = await get(dbRef);
      if (snapshot.exists()) {
          return snapshot.val();
      } else {
          return null;
      }
  } catch (error) {
      console.error("Error fetching user preferences:", error);
      throw error;
  }
};